import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ConfigService } from 'src/app/provider/config.service';
// import { Subscription } from 'rxjs';

@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss'],
  standalone: false,
})
export class PopupModalComponent implements OnInit, OnDestroy {
  @Input() allBanners?: any[];
  public settings?: any;
  private appSettingsSubscription?: Subscription;

  constructor(private modalController: ModalController, private router: NavController, private configService: ConfigService) {}

  ngOnInit() {
    this.appSettingsSubscription = this.configService.appSettings$.subscribe((currentSettings: any) => {
      this.settings = currentSettings;
    });
  }

  ngOnDestroy() {
    this.appSettingsSubscription?.unsubscribe();
  }

  /**
   * Dismisses the modal.
   */
  async dismiss() {
    await this.modalController?.dismiss();
  }

  /**
   * Handles the "Learn More" button click.
   * You can add navigation or other logic here.
   */
  learnMore() {
    // Example: You might want to dismiss the modal and then navigate
    this.dismiss();
    this.router?.navigateRoot(['/subscription-list']);
  }
}
